import { ReactComponent as AssignIcon } from 'icons/assign-report-icon-dark.svg'
import { FC, PropsWithChildren } from 'react'
import { StyledTakeActionIconWrapper } from './icon-wrapper/styledTakeActionIconWrapper'


export interface IAssignReportIcon {
    fill?: string
    active?: boolean
    size?: number
}

export const AssignReportIcon: FC<PropsWithChildren<IAssignReportIcon>> = () => {
    return (
        <StyledTakeActionIconWrapper>
            <AssignIcon />
        </StyledTakeActionIconWrapper>
    )
}
